import React from "react";
import { useTranslation } from "react-i18next";
const HomeEdit = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="d-flex flex-column align-items-center">
        <i className="circleTop icon-house text-center"></i>
        <div className="text-center mt-2">
          <p className="m-0">{t("خانه من")}</p>
        </div>
      </div>
      <div className="mt-4 mb-3">
        <div
          className="d-flex justify-content-between align-items-center pb-2 pt-4"
          style={{ borderBottom: "3px solid #EBEBEB" }}
        >
          <div className="d-flex">
            <i className="ml-3">i</i>
            <p className="m-0 fn12">{t("حذف خانه")}</p>
          </div>
          <i
            className="icon-down-open-big fn12 rotateIcon"
            style={{ color: "#D4DBE3" }}
          ></i>
        </div>
        <div
          className="d-flex justify-content-between align-items-center pb-2 pt-4"
          style={{ borderBottom: "3px solid #EBEBEB" }}
        >
          <div className="d-flex">
            <i className="ml-3">i</i>
            <p className="m-0 fn12">{t("اعلان")}</p>
          </div>
          <i
            className="icon-down-open-big fn12 rotateIcon"
            style={{ color: "#D4DBE3" }}
          ></i>
        </div>
        <div
          className="d-flex justify-content-between align-items-center pb-2 pt-4"
          style={{ borderBottom: "3px solid #EBEBEB" }}
        >
          <div className="d-flex">
            <i className="ml-3 icon-plug"></i>
            <p className="m-0 fn12">{t("دستگاه ها")}</p>
          </div>
          <i
            className="icon-down-open-big fn12 rotateIcon"
            style={{ color: "#D4DBE3" }}
          ></i>
        </div>
      </div>
    </>
  );
};

export { HomeEdit };
